import Typography from '@mui/material/Typography';
import {LinkPopover} from '@vedmarket/ui-kit';
import {useTranslation} from 'react-i18next';
import {formatReferenceCopy} from 'utils/typography';

import './commission-help.scss';

const CommissionHelp = ({isCurrencyControl = false}: CalculatorCommissionHelpProps) => {
  const {t} = useTranslation();

  const actualTextKey = isCurrencyControl
    ? 'calc__help__currencyControlFeesActual'
    : 'calc__help__bankTransferFeesActual';
  const estimateTextKey = isCurrencyControl
    ? 'calc__help__currencyControlFeesEstimate'
    : 'calc__help__bankTransferFeesEstimate';

  return <div className='commission-help'>
    <LinkPopover
      linkText={t('calc__help__paymentFeesLink')}
      text={<div className='commission-help__content'>
        <Typography variant='inherit'>
          {formatReferenceCopy(t(actualTextKey))}
        </Typography>
        <Typography variant='inherit'>
          {formatReferenceCopy(t(estimateTextKey))}
        </Typography>
      </div>}
    />
  </div>;
};

export default CommissionHelp;
